import createSelector from "../../utils/reselect";

const risksStateData = (state) => {
  const { risks } = state;
  return risks || {};
};

export const getError = createSelector(risksStateData, (risks) =>
  risks.get("error")
);

export const riskStatusLoading = createSelector(risksStateData, (risks) =>
  risks.get("riskStatusLoading")
);

export const risks = createSelector(risksStateData, (risks) =>
  risks.get("risks")
);

export const riskLoading = createSelector(risksStateData, (risks) =>
  risks.get("riskLoading")
);

export const riskPagination = createSelector(risksStateData, (risks) =>
  risks.get("riskPagination")
);
